export default __webpack_public_path__ + "static/media/9.be90486b.webp";